import { Dispatch } from "redux";
import { setAxnAdminConfigRefreshResults, setAxnAdminConfigRefreshing } from "@redux/actions/axn-admin-config-actions";
import { refreshAxnAdminConfigRequest } from "@requests/management-console/refresh-axn-admin-config";
import { RefreshResult } from "@idw-types/common";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const refreshAxnAdminConfigReduxRequest = (dispatch: Dispatch) => async (): Promise<Array<RefreshResult>> => {
    dispatch(setAxnAdminConfigRefreshResults(null, null));
    dispatch(setAxnAdminConfigRefreshing(true));
    const { data, error } = await refreshAxnAdminConfigRequest();

    const lastRefreshDate = new Date();

    if (data) {
        dispatch(setAxnAdminConfigRefreshResults(data, lastRefreshDate));
        return data;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.refreshAxnAdminConfig.error.title,
                resources.requests.refreshAxnAdminConfig.error.message
            );
        }
        dispatch(setAxnAdminConfigRefreshResults(null, lastRefreshDate));
        return null;
    }
};